export default __webpack_public_path__ + "static/media/CDProjektRed.840da276.svg";